import {RutsolveToken} from "@/storage/rutsolve_token"
import {ClientError, GraphQLClient} from "graphql-request"
import {InvalidCredentialsError} from "@/endpoints/rutsolve/gql/errors/invalid_credentials"
import {SuspendedError} from "@/endpoints/rutsolve/gql/errors/suspended"
import {InvalidTokenError} from "@/endpoints/rutsolve/gql/errors/invalid_token"
import {UnauthorizedError} from "@/endpoints/rutsolve/gql/errors/unauthorized"

export class Client {
    client: GraphQLClient

    constructor() {
        this.client = new GraphQLClient(process.env.VUE_APP_RUTSOLVE_GRAPHQL)
        this.client.setHeader("Authorization", RutsolveToken.read())
    }

    // Convert a string to a date.
    protected date(input: string): Date {
        if (input == null) {
            return null
        }
        return new Date(input)
    }

    // Convert a number to a decimal.
    protected decimal(input: number): string {
        if (input == null) {
            return null
        }
        return input.toString()
    }

    protected handleError(error: Error) {
        if (error instanceof ClientError) {
            this.handleClientError(error)
        }
        throw error
    }

    private handleClientError(error: ClientError) {
        if (error.message.includes("credentials")) {
            throw new InvalidCredentialsError(error)
        }
        if (error.message.includes("token")) {
            throw new InvalidTokenError(error)
        }
        if (error.message.includes("suspended")) {
            throw new SuspendedError(error)
        }
        if (error.message.includes("unauthorized")) {
            throw new UnauthorizedError(error)
        }
    }
}
